import { connect } from 'react-redux';

import { IState } from '../../store';
import { HomeownerBlockAside, IHomeownerBlockAsideProps } from './HomeownerBlockAside';

export const mapStateToProps = (state: IState): IHomeownerBlockAsideProps => {
  const { offerData: { agent, offer } } = state;

  return { agent, offer };
};

export const HomeownerBlockAsideContainer = connect(mapStateToProps)(HomeownerBlockAside);
